module.exports = __webpack_public_path__ + "img/beian.b628e484.png";